const Modal = ({ open, onClose , children,title,Submit}) => {
    if (!open) return null;
  
    return (
      <div
        className={`modal ${open ? "show" : ""}`}
        tabIndex="-1"
        aria-hidden={!open}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
                {children}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary cursor-pointer"
                onClick={onClose}
              >
                Close
              </button>
              <button type="button" onClick={Submit} className="btn btn-primary cursor-pointer">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default Modal;